var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0703 3.02227C9.98223 3.43243 9.68975 3.76836 9.62481 4.26517C10.5158 3.87409 11.3504 3.50105 12.1905 3.13991C13.6263 2.54007 15.0228 1.84629 16.3713 1.06286C17.3586 0.475897 18.442 0.317647 19.5708 0.37524C20.4744 0.421455 21.3798 0.434059 22.2842 0.465044C22.4559 0.440613 22.6307 0.475289 22.7811 0.563602C22.662 0.7138 22.4726 0.716075 22.3308 0.810605C22.108 0.960104 22.0347 1.11975 22.3354 1.24509C23.5146 1.73525 24.6389 2.38769 25.944 2.5104C26.4464 2.55749 26.7185 2.42043 26.9579 1.96335C27.2104 1.48107 27.2086 0.945049 27.29 0.426182C27.3163 0.257777 27.2846 0.0163746 27.5011 0.00061956C27.6979 -0.01356 27.7485 0.218741 27.8047 0.380318C27.9826 0.891366 28.1391 1.40947 28.2741 1.93464C28.349 2.20428 28.3529 2.4893 28.2856 2.76098C28.2182 3.03267 28.082 3.28141 27.8905 3.48214C27.4769 3.9586 26.9229 4.28488 26.3121 4.41187C25.2718 4.6361 24.2604 4.98268 23.2982 5.4447C23.1954 5.49564 23.0352 5.49214 23.0278 5.68645C23.2553 5.73127 23.4407 5.45888 23.672 5.59367C23.6698 5.62868 23.6768 5.67717 23.6654 5.68243C23.1059 5.93433 23.121 6.36707 23.2649 6.87894C23.4607 7.48999 23.4522 8.15018 23.2406 8.75572C22.7422 10.176 23.6808 12.0606 25.0462 12.6026C25.3849 12.7252 25.7078 12.889 26.0081 13.0905C26.2706 13.2776 26.3083 13.4821 26.1281 13.7602C25.6849 14.4697 25.0593 15.0409 24.3196 15.4114C23.6525 15.7392 23.5699 15.8819 23.6371 16.6439C23.6657 16.968 23.4954 17.0571 23.2362 17.0849C23.1522 17.0938 23.0497 17.0849 23.016 17.1845C22.9764 17.3023 23.092 17.3246 23.1572 17.3669C23.3215 17.476 23.3662 17.6188 23.2418 17.7736C22.4634 18.7422 22.3114 19.9217 22.1341 21.1009C22.0006 21.9884 21.7842 22.1024 20.9026 21.9937C19.9043 21.8793 18.9147 21.6956 17.9408 21.444C17.8041 21.3941 17.6543 21.3974 17.5199 21.4531C17.3854 21.5088 17.2757 21.6131 17.2117 21.7461C16.9368 22.2279 16.6945 22.7283 16.4866 23.2439C16.4453 23.3208 16.4316 23.4099 16.4479 23.496C16.4641 23.5821 16.5093 23.6597 16.5755 23.7153C16.6663 23.8002 16.7395 23.9028 16.7909 24.0171C16.8423 24.1313 16.8707 24.2549 16.8747 24.3806C16.8747 24.7977 16.9028 25.2023 17.1673 25.5501C17.1958 25.5874 17.2107 25.6858 17.1893 25.7038C17.063 25.8113 16.997 25.6338 16.8916 25.6236C16.8546 25.5853 16.814 25.541 16.7674 25.6012C16.7585 25.6126 16.7979 25.6632 16.8151 25.6956C17.5804 26.3442 17.9266 27.2065 18.1416 28.18C18.425 29.4614 18.804 30.7209 19.1421 31.9897L7.34749 31.9999C7.21795 31.9999 7.0855 32.0085 7 31.8773C7.24091 30.5469 7.87848 29.4113 8.62948 28.3227C9.66936 26.8156 10.4077 25.1452 11.1052 23.4542C11.2166 23.184 11.1707 23.0204 10.8986 22.897C10.6395 22.7793 10.6135 22.5643 10.731 22.3082C10.9744 21.8092 11.247 21.3257 11.5473 20.8602C11.7373 20.5489 12.0356 20.5878 12.3197 20.6396C12.5082 20.6746 12.6403 20.6895 12.7261 20.463C13.1346 19.383 13.5923 18.3215 13.8155 17.177C13.8597 16.9314 13.8235 16.6779 13.7127 16.4554C12.6927 14.1496 11.3824 12.045 9.64074 10.2311C8.90599 9.44373 8.28495 8.55329 7.79641 7.58669C7.75254 7.50301 7.6936 7.42739 7.62729 7.32411C7.46657 7.58407 7.60416 7.80726 7.62506 8.06985C7.56433 8.04166 7.51153 7.99828 7.47155 7.94372C7.43157 7.88917 7.40569 7.8252 7.39631 7.75772C7.26815 7.25688 7.46057 6.7599 7.40283 6.24331C7.34029 5.6854 7.80086 5.33967 8.22031 5.03647C8.41674 4.8636 8.56994 4.64533 8.66717 4.39979C8.96749 3.79419 9.44547 3.29955 10.0343 2.98498C10.046 2.99636 10.0581 3.00967 10.0703 3.02227ZM16.6566 25.4088C16.6331 25.4302 16.5978 25.4535 16.6009 25.4614C16.6167 25.494 16.6358 25.5249 16.6579 25.5534C16.6763 25.5389 16.7121 25.5184 16.7093 25.5111C16.6949 25.4754 16.6772 25.4412 16.6566 25.4088Z",
    fill: "url(#paint0_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di",
    x: -33,
    y: -25,
    width: 101.333,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.213889 0 0 0 0 0.666667 0 0 0 0 0.297848 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.364706 0 0 0 0 0.956863 0 0 0 0 0.47451 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 14.2299,
    y1: 4,
    x2: -1.98095,
    y2: 32.5049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FEC6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20CB3D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreen);
export default __webpack_public_path__ + "static/media/icon_green.6815cb09684869ee10a3d92d988dc6e6.svg";
export { ForwardRef as ReactComponent };